module.exports = __webpack_public_path__ + "img/11_59.a9f964ab.png";